<template>
  <div
    class="img-fluid"
    :style="{
      backgroundImage: `url(${src})`,
      paddingBottom: '100%',
      width: '100%',
      backgroundSize: 'cover'
    }"
  />
</template>

<script>
export default {
  name: 'Photo',
  props: {
    src: String
  },
}
</script>